import { createContext, useState } from "react";
import { notify } from "../../../utils/utils";
import services from '../../../services/index'
import commonObj from '../../../utils/Common';

export const AuthContext = createContext();

const AuthContextProvider = ({ children }) => {
  const [token, setToken] = useState(localStorage.getItem("token"));
  const [IsUserRegistered, setUserRegistered] = useState(false)
  const [userInfo, setUserInfo] = useState(
    localStorage.getItem("userInfo")
      ? JSON.parse(localStorage.getItem("userInfo"))
      : null
  );
  const [loggingIn, setLoggingIn] = useState(false);
  const [signingUp, setSigningUp] = useState(false);

  const signupHandler = async ({
    firstName = "",
    lastName = "",
    email = "",
    mobile = "",
    password = "",
    ut = "",
    isAgree = 0,
    categoryId = "",
  }) => {
    setSigningUp(true);
    try {
      const response = await services.usersService.addUser({firstName, lastName, email, mobile, password,isAgree,ut,categoryId});
      console.log(response);
      if (response.status === 1) {
        setUserRegistered(true);
        notify("success", commonObj.getLabel('Signed_Up_Successfully'));
      }
    } catch (err) {
      console.log(err);
      /*notify(
        "error",
        err?.response?.data?.errors
          ? err?.response?.data?.errors[0]
          : "Some Error Occurred!!"
      );*/
    } finally {
      setSigningUp(false);
    }
  };

  const loginHandler = async ({ email = "", password = "",otp = "",inputotp = "", mobile="" }) => {
    setLoggingIn(true);
    try {
      const response = await services.loginService.getlogin({email:email, mobile:mobile, password:password ,otp:otp, inputotp:inputotp, role:'front'});
      console.log({ response });
      if (response?.status === 1) {
        localStorage.setItem("token", response?.data?.token);
        localStorage.setItem(
          "userInfo",
          JSON.stringify(response?.data?.user)
        );
        setToken(response?.data?.token);
        setUserInfo(response?.data?.user)
        notify("success", commonObj.getLabel('Logged_In_successfully'));
      }
    } catch (err) {
      console.log(err);
      /*notify(
        "error",
        err?.response?.data?.errors
          ? err?.response?.data?.errors[0]
          : "Some Error Occurred!!"
      );*/
    } finally {
      setLoggingIn(false);
    }
  };

  const logoutHandler = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("userInfo");
    localStorage.removeItem("sanhivtest");
    setToken(null);
    notify("info", commonObj.getLabel('Logged_out_successfully'), 100);
  };
  return (
    <AuthContext.Provider
      value={{
        token,
        loggingIn,
        loginHandler,
        logoutHandler,
        signupHandler,
        signingUp,
        userInfo,
        IsUserRegistered,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContextProvider;
